import { SpinnerIcon } from '@/lib/Spinner';
import { type FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { styles } from './Button.styles';
import type { ButtonProps } from './types';

export const Button: FC<ButtonProps> = ({
  intent = 'primary',
  size = 'sm',
  isLoading = false,
  onClick = () => {},
  text,
  children,
  disabled,
  className,
  ...props
}) => {
  return (
    <button
      type='button'
      disabled={disabled || isLoading}
      data-loading={isLoading}
      onClick={onClick}
      className={twMerge(styles({ intent, size, isLoading }), 'group/button', className)}
      {...props}
    >
      {isLoading ? (
        <SpinnerIcon
          className='size-5'
          pathClassName={twMerge('text-quaternary-400', intent === 'primary' ? 'stroke-primary-icon' : '', intent === 'link-color' && 'text-brand-500')}
        />
      ) : null}
      {text ? text : children}
    </button>
  );
};
